var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useContext, useEffect } from 'react';
import { useRouter } from '@curi/react-dom';
import toast from 'react-hot-toast'; //@ts-ignore
import Helmet from 'react-helmet';
import { ProfileContext } from '__state/Profile';
import { subscribeToPartyInfo } from 'services';
import './WatchParty.scss';
import HeaderApp from 'components/HeaderApp';
import LoginPopover from 'components/LoginPopover';
import MenuButton from '__assets/images/button__menu.svg';
import CloseMenuButtonWhite from '__assets/images/button__close-white.svg';
import InviteButton from '__assets/images/button__invite.svg';
import ChatButton from '__assets/images/button__chat.svg';
import MultiUsersButton from '__assets/images/button__multi-users.svg';
import ChatScreen from './screens/Chat';
import Members from './screens/Members';
var SCREENS = {
    CHAT: 'chat',
    MEMBERS: 'members',
};
var baseClass = 'page__watchparty';
var WatchParty = function () {
    var router = useRouter();
    var profile = useContext(ProfileContext).profile;
    var _a = useState(false), isMenuOpen = _a[0], setIsMenuOpen = _a[1];
    var _b = useState(SCREENS.CHAT), screen = _b[0], setScreen = _b[1];
    var _c = useState(), partyInfo = _c[0], setPartyInfo = _c[1];
    useEffect(function () {
        var unsubInfo = subscribeToPartyInfo(function (party) {
            setPartyInfo(party);
        });
        return function () { return unsubInfo(); };
    }, []);
    var handleNavigation = function (route) {
        setIsMenuOpen(false);
        var url = router.url({ name: route });
        router.navigate({ url: url });
    };
    var handleMembers = function (e) {
        e.preventDefault();
        if (!profile) {
            return false;
        }
        setScreen(SCREENS.MEMBERS);
    };
    var handleInvite = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!partyInfo) {
                        toast.error('Something went wrong getting the party\'s info. Please try again or contact us.');
                        return [2 /*return*/, false];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText("Come chat with us in the " + (partyInfo === null || partyInfo === void 0 ? void 0 : partyInfo.name) + " watch party! " + window.location.href)];
                case 2:
                    _a.sent();
                    toast.success('The watch party saved to your clipboard. Share it in your apps!');
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    toast.error('Something went wrong copying to the clipboard. Please try again or contact us.');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var renderScreen = function () {
        var chatOpts = {
            baseClass: baseClass,
            profile: profile,
            party: partyInfo,
        };
        var membersOpts = {
            baseClass: baseClass,
            party: partyInfo,
        };
        switch (screen) {
            case SCREENS.MEMBERS:
                return _jsx(Members, __assign({}, membersOpts), void 0);
            default:
                return _jsx(ChatScreen, __assign({}, chatOpts), void 0);
        }
    };
    if (!partyInfo) {
        return null;
    }
    var appDescription = "Come chat with us in the " + partyInfo.name + " watch party!";
    return (_jsxs("div", __assign({ className: baseClass }, { children: [_jsxs(Helmet, { children: [_jsxs("title", { children: ["Collyde | ", partyInfo.name] }, void 0), _jsx("meta", { name: "description", content: appDescription }, void 0)] }, void 0), partyInfo.showHeadingInChat && (_jsx(HeaderApp, { party: partyInfo }, void 0)), _jsxs("div", __assign({ className: baseClass + "__misc-header" }, { children: [profile && (_jsx("button", __assign({ title: "App menu", className: baseClass + "__hbutton " + baseClass + "__hbutton--app-menu", onClick: function () { return setIsMenuOpen(!isMenuOpen); } }, { children: _jsx("img", { alt: "", src: MenuButton }, void 0) }), void 0)), _jsx("button", __assign({ title: "Copy Link to " + partyInfo.name, className: baseClass + "__hbutton " + baseClass + "__hbutton--invite-fans", onClick: handleInvite }, { children: _jsx("img", { alt: "", src: InviteButton }, void 0) }), void 0), _jsx("button", __assign({ title: "Chat", className: baseClass + "__hbutton " + baseClass + "__hbutton--chat", onClick: function () { return setScreen(SCREENS.CHAT); } }, { children: _jsx("img", { alt: "", src: ChatButton }, void 0) }), void 0), _jsxs("button", __assign({ className: baseClass + "__hbutton " + baseClass + "__hbutton--fan-count", onClick: handleMembers }, { children: [_jsx("img", { alt: "", src: MultiUsersButton }, void 0), partyInfo.membersCount] }), void 0)] }), void 0), renderScreen(), !profile && _jsx(LoginPopover, {}, void 0), _jsxs("div", __assign({ className: "\n        " + baseClass + "__app-menu \n        " + (isMenuOpen ? 'is-open' : '') + " \n        " + (partyInfo.showHeadingInChat ? 'heading-pad' : '') + "\n      " }, { children: [_jsx("button", __assign({ className: "close-button", onClick: function () { return setIsMenuOpen(false); } }, { children: _jsx("img", { alt: "", src: CloseMenuButtonWhite }, void 0) }), void 0), _jsxs("ul", { children: [_jsx("a", __assign({ onClick: function () { return handleNavigation('Party'); } }, { children: _jsx("li", { children: "Party" }, void 0) }), void 0), _jsx("a", __assign({ onClick: function () { return handleNavigation('Profile'); } }, { children: _jsx("li", { children: "Profile" }, void 0) }), void 0), _jsx("a", __assign({ onClick: function () { return handleNavigation('Settings'); } }, { children: _jsx("li", { children: "Settings" }, void 0) }), void 0)] }, void 0)] }), void 0)] }), void 0));
};
export default WatchParty;
